// loadImage.js
const cache = {};

export async function loadImage(imageKey) {
  if (cache[imageKey]) return cache[imageKey];

  try {
    const mod = await import(`./images/webP/${imageKey}.webp`);
    cache[imageKey] = mod.default;
    return mod.default;
  } catch (err) {
    console.error(`loadImage: no webp found for key "${imageKey}", falling back to snowman.webp`, err);
    const fallback = (await import("./images/webP/snowman.webp")).default;
    cache[imageKey] = fallback;
    return fallback;
  }
}
